import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';

export class StudentGraduationPacingModel {
	@Transform(dateTransformer)
	estimate_graduation_date: Date;
	@Transform(dateTransformer)
	target_end_date: Date;
	monthly_credit_rate: number;
	status: string;
	type: 'cohort_year' | 'end_date';
}

export function StudentGraduationPacingModel_ClassTransform_Type() {
	return StudentGraduationPacingModel;
}
